import { ExtranetModule } from "../../modules-access/extranet-module.enum";

export enum NotificationBarTypes {
    Information = 'Information',
    Warning = 'Warning',
}

export enum NotificationSource {
    Shipment = "shipment",
    Agencies = "agencies",
    Logistics = "logistics",
    Settlements = "settlements",
}

export interface NotificationBarModel {
    id: number;
    type: NotificationBarTypes;
    modules: NotificationSource[];
    htmlMessage: string;
    title?: string;
    from: Date;
    to: Date;
    closeable: boolean;
}

export const closedIdsKey = 'closedIds';
export const rejectedIdsKey = 'rejectedIds';
